import classNames from 'classnames';
import moment from 'moment';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import decorIconSubject from '../../assets/img/icon-girl-book.png';
import Loader from '../../Components/Loader';
import NoItems from '../../Components/NoItems';
import Pagination from '../../Components/Pagination';
import { getUser } from '../../redux/slices/userSlice';
import './style.scss';

const Home = () => {
  const currentUser = useSelector(getUser);
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [postPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeUser, setActiveUser] = useState(false);

  const end = currentPage * postPerPage;
  const start = end - postPerPage;
  const currentPosts = items.slice(start, end);
  const paginate = pageNumber => {
    if (pageNumber != currentPage) setCurrentPage(pageNumber);
  };

  useEffect(() => {
    fetch(
      'https://graph.facebook.com/me?fields=id,name,posts.limit(100){message,created_time,full_picture,permalink_url}&access_token=EAACJ9ZASuOMQBO3Ys48Wd0xpgMejkkbGmLLRhns4OcS78UTCb0V9iRRggJc7AKM6rpDehNPeOuR8UpAiQ1zqLl581rK59j0v4aflKe2sZC5yMhDiLCQhqNnWuyAhGFKXZC9eSxn5aeY1oxYRmf6fUN6JkK0VfX9AI1ZA52OejmmQr36YuAuvf7plWiMQFffH',
    )
      .then(response => {
        return response.json();
      })
      .then(data => {
        const postsArr = data.posts.data.filter(item => item.message && item.full_picture && item.id);
        setIsLoaded(true);
        setItems(postsArr);
        setTotalPages(postsArr.length);
      })
      .catch(error => {
        setIsLoaded(true);
        setError(error);
      });

    if (currentUser && currentUser.active === false) {
      setActiveUser(true);
    }
  }, [currentUser]);

  return (
    <>
      <div className="home-page container">
        <div className="title-wrap">
          <h1>{t('homePage')}</h1>
        </div>
        {!isLoaded ? (
          <Loader />
        ) : (
          <>
            <ul className="home-list">
              {currentPosts.map(item =>
                item.full_picture && item.message ? (
                  <li className="home-list_item" key={item.id} id={item.id}>
                    <div className="img-wrap">
                      <a href={item.permalink_url} target="_blank" rel="noreferrer">
                        <img src={item.full_picture ? item.full_picture : ''} alt="facebook-img" />
                      </a>
                    </div>
                    <div className="content">
                      <div className="content-top">
                        <p>{item.message}</p>
                      </div>
                      <div className="content-bottom">
                        <a href={item.permalink_url} target="_blank" className="btn btn-primary more" rel="noreferrer">
                          {t('reedMore')}
                        </a>
                        <time className="public-date">{moment(item.created_time).format('DD.MM.YYYY')}</time>
                      </div>
                    </div>
                  </li>
                ) : null,
              )}
              {currentPosts.length === 0 && (
                <div>
                  <NoItems titleNoItems={'noPosts'} />
                </div>
              )}
            </ul>
            <div className="pagination-wrap">
              {currentPosts && currentPosts.length > 0 && (
                <Pagination totalItems={totalPages} itemsPerPage={postPerPage} onPaginate={paginate} />
              )}
            </div>
            <div className="decor-item-img">
              <img src={decorIconSubject} alt="decor-icon" />
            </div>
          </>
        )}
      </div>
      <div
        className={classNames('modal-form block-user', {
          open: activeUser,
        })}
        onClick={() => {
          setActiveUser(false);
        }}
      >
        <div
          className="modal-form-content"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className="modal-header">
            <button
              className="btn btn-icon"
              onClick={e => {
                setActiveUser(false);
                e.preventDefault();
              }}
            >
              <span className="icon icon-plus"></span>
            </button>
          </div>
          <div className="modal-body">
            <p>{t('Access to your account is temporarily limited.')}</p>
            <p>{t('Contact your Logos Learning Platform Administrator!')}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
